import ReferencePhoto from './referencephoto'

export default ReferencePhoto